import { Container } from 'src/components/common/Container'
import styled, { css } from 'styled-components'
import { Typography } from 'src/components/common/Typography'
import { Noto_body3_r12, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import { CustomSwiper } from 'src/components/common/CustomSwiper'
import { MainPageProps } from 'src/pages/MainPage'
import React, { useEffect, useRef, useState } from 'react'
import { Roboto_num2_b16, Roboto_num4_r12 } from 'src/styles/fonts/RobotoFonts'
import { ellip, mediaMaxWidth } from 'src/styles/mixin'
import useResizeEventListener from 'src/hooks/useResizeEventListener.hook'
import LazyImage from 'src/components/common/LazyImage'
import usePageNav from 'src/hooks/usePageNav.hook'
import RenderIf from 'src/components/common/RenderIf'
import Skeleton from 'react-loading-skeleton'

const MainPopularCoupon = ({ popularCouponList }: MainPageProps) => {
  const { alwaysCouponDetailPageNav } = usePageNav()
  const containerRef = useRef<HTMLDivElement>(null)
  const [left, setLeft] = useState<string>('0px')

  const calculateLeftPosition = () =>
    setLeft(`${(containerRef?.current?.clientWidth! - 420) / 2}px`)

  useEffect(() => {
    const rafId = requestAnimationFrame(calculateLeftPosition)
    return () => {
      window.cancelAnimationFrame(rafId)
    }
  }, [])

  useResizeEventListener(calculateLeftPosition)

  return (
    <S.MainPopularCouponContainer ref={containerRef}>
      <S.MainPopularCouponContents $option="flex_column" $row_gap="10px" $left={left}>
        <S.MainPopularPrimaryText $fontStyle={Noto_subheading_b18}>
          지금 인기 있는 상품
        </S.MainPopularPrimaryText>
        <CustomSwiper.Wrap type="default" $wrapstyle={S.PopularCouponListSwiperStyle}>
          {popularCouponList?.map(
            (
              {
                CouponName,
                DiscountRate,
                SalePrice,
                RegularPrice,
                CouponImage,
                CouponNumber,
                CouponIdx,
              },
              p_i: number,
            ) => (
              <CustomSwiper.Item
                key={p_i}
                $itemstyle={S.PopularCoupon.SwiperItems(p_i === 0)}
                onClick={() => alwaysCouponDetailPageNav(`${CouponNumber}`, CouponIdx)}
              >
                <LazyImage src={CouponImage} alt="쿠폰" style={S.PopularCoupon.CouponImage} />
                <RenderIf when={!!SalePrice}>
                  <Container $option="flex_row" $column_gap="4px">
                    <S.PopularCoupon.DiscountRate
                      $fontStyle={Roboto_num2_b16}
                      $color="var(--brand-50)"
                    >
                      {Math.floor((DiscountRate as number) * 10) / 10}%
                    </S.PopularCoupon.DiscountRate>
                    <S.PopularCoupon.RegularPrice $fontStyle={Roboto_num2_b16}>
                      {SalePrice?.toLocaleString()}원
                    </S.PopularCoupon.RegularPrice>
                  </Container>
                  <S.PopularCoupon.SalePrice $fontStyle={Roboto_num4_r12} $color="var(--black-30)">
                    {RegularPrice?.toLocaleString()}원
                  </S.PopularCoupon.SalePrice>
                  <S.PopularCoupon.CouponName $fontStyle={Noto_body3_r12} $color="var(--black-90)">
                    {CouponName}
                  </S.PopularCoupon.CouponName>
                </RenderIf>
                <RenderIf when={!SalePrice}>
                  <Skeleton count={2} style={{ marginBottom: '5px' }} />
                </RenderIf>
              </CustomSwiper.Item>
            ),
          )}
        </CustomSwiper.Wrap>
      </S.MainPopularCouponContents>
    </S.MainPopularCouponContainer>
  )
}
export default MainPopularCoupon

const S = {
  MainPopularCouponContainer: styled(Container)`
    background: var(--white);
    padding: 20px 0;

    ${mediaMaxWidth('460')} {
      padding: 20px 0;
    }
  `,
  MainPopularPrimaryText: styled(Typography)`
    ${mediaMaxWidth('460')} {
      padding: 0 20px;
    }
  `,
  MainPopularCouponContents: styled(Container)<{ $left: string }>`
    position: relative;
    width: calc(100% - ${(props) => props.$left});
    max-width: 688px;
    left: ${(props) => props.$left};

    ${mediaMaxWidth('460')} {
      width: 100%;
      left: 0;
    }
  `,
  PopularCouponListSwiperStyle: css`
    display: flex;
    flex-direction: row;
    gap: 10px;
    width: 100%;
    padding-right: 20px;
  `,
  PopularCoupon: {
    SwiperItems: (firstIndex: boolean) => css`
      display: flex;
      flex-direction: column;
      width: 120px;
      margin-right: 10px;
      ${mediaMaxWidth('460')} {
        margin-right: 0;
        margin-left: ${firstIndex ? '20px' : '10px'};
      }
    `,
    CouponImage: css`
      padding: 10px;
      width: 120px;
      height: 120px;
      border-radius: 12px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      margin-bottom: 6px;
      > img {
        border-radius: inherit;
      }
      &:hover {
        transform: scale(1.05);
      }
    `,
    DiscountRate: styled(Typography)``,
    SalePrice: styled(Typography)`
      margin: 2px 0;
      text-decoration: line-through;
    `,
    RegularPrice: styled(Typography)``,
    CouponName: styled(Typography)`
      ${ellip('line2')};
      word-break: keep-all;
    `,
  },
}
